<template>

  <a-row :gutter="[8, 12]" align="middle" wrap style="margin-top: 15px;">
    <!-- Sender Address -->
    <a-col :xs="24" :sm="12" :md="6" :lg="4">
      <a-input
        v-model:value="senderAddress"
        placeholder="发送方地址"
        allow-clear
        :style="inputStyle"
      />
    </a-col>

    <!-- Receiver Address -->
    <a-col :xs="24" :sm="12" :md="6" :lg="4">
      <a-input
        v-model:value="receiverAddress"
        placeholder="接收方地址"
        allow-clear
        :style="inputStyle"
      />
    </a-col>

    <!-- Date Range -->
    <a-col :xs="24" :sm="24" :md="8" :lg="6">
      <a-range-picker
        v-model:value="dateRange"
        :style="inputStyleFull"
        :placeholder="['开始时间', '结束时间']"
        allow-clear
      />
    </a-col>

    <!-- Token Type -->
    <a-col :xs="24" :sm="12" :md="6" :lg="3">
      <a-select
        v-model:value="selectedToken"
        :options="tokenTypes"
        placeholder="Token"
        allow-clear
        :style="inputStyleFull"
      />
    </a-col>

    <!-- Hide Small -->
    <a-col :xs="24" :sm="12" :md="6" :lg="3">
      <a-select
        v-model:value="hideSmall"
        :options="smallBalances"
        placeholder="不隐藏小额"
        allow-clear
        :style="inputStyleFull"
      />
    </a-col>

    <!-- Buttons -->
    <a-col :xs="24" :sm="24" :md="12" :lg="4">
      <div style="display: flex; justify-content: flex-end; gap: 8px">
        <a-button @click="clearFilters" :style="buttonStyle">清 空</a-button>
        <a-button type="primary" @click="handleFilter" :style="buttonStyle">筛 选</a-button>
      </div>
    </a-col>
  </a-row>

  <div class="transfer-type-options" style="margin-top: 24px; display:none;">
    <span
      v-for="option in options"
      :key="option.value"
      :class="['badge', { active: transferType === option.value }]"
      @click="selectOption(option.value)"
    >
      {{ option.label }}
    </span>
  </div>
  
  <div class="summary-box" style="margin-top: 10px;">
    <div>
      <span>共计</span>
      <span class="badge badge-success">{{ totalTransfers }}</span>
      <span>条数据</span>
    </div>
    <div>
      <span>收入</span>
      <span class="badge badge-success"> {{ parseFloat(currentTransfersIn).toFixed(4) }}</span>
    </div>
    <div>
      <span>支出</span>
      <span class="badge badge-success">{{ parseFloat(currentTransfersOut).toFixed(4) }}</span>
    </div>
    <div>
      <span>交易合计</span>
      <span class="badge"
        :class="{
          'badge-success': currentTransfersIn - currentTransfersOut >= 0,
          'badge-danger': currentTransfersIn - currentTransfersOut < 0
        }">
        {{ (currentTransfersIn - currentTransfersOut).toFixed(4) }}
      </span>
    </div>
  </div>

  <div style="overflow-x: auto; -webkit-overflow-scrolling: touch;">
    <table class="ant-table">
      <thead class="ant-table-thead">
        <tr>
          <th class="ant-table-cell ant_table ant_table_padding_right_none" style="text-align: center;">
            <a-tooltip title="点击查看交易明细预览">
              <div class="question-mark">
                <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                  <use xlink:href="/static/media/icons.svg#icon-icon-ask" />
                </svg>
              </div>
            </a-tooltip>
          </th>

          <th class="ant-table-cell ant_table text-left">
            <span class="token-change-type default">
              <span class="mr-1 d-flex">
                <a-tooltip title="账户上次交易的日期和时间">
                  <div class="question-mark">
                    <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                      <use xlink:href="/static/media/icons.svg#icon-icon-ask" />
                    </svg>
                  </div>
                </a-tooltip>
              </span>
              <span>交易时间 <svg class="icon tron-icon icon-block-age" aria-hidden="true"><use xlink:href="/static/media/icons.svg#icon-block-age"></use></svg></span>
            </span>
          </th>

          <th class="ant-table-cell ant_table from_address text-left">发送方</th>          
          <th class="ant-table-cell ant_table to_address text-left">接收方</th>
          <th class="ant-table-cell ant_table text-left">代币</th>

          <th class="ant-table-cell ant_table text-left">
            <div class="d-flex align-items-center">
              <a-tooltip title="显示交易类型。如果交易类型为“触发智能合约”，则会显示详细方法">
                <div class="question-mark">
                  <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                    <use xlink:href="/static/media/icons.svg#icon-icon-ask" />
                  </svg>
                </div>
              </a-tooltip>
              <span>类型</span>
            </div>
          </th>

          <th class="ant-table-cell ant_table text-right">金额</th>
          
          <th class="ant-table-cell ant_table text-left">区块ID</th>
          <th class="ant-table-cell ant_table text-left">交易哈希</th>
          
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(tx, index) in transfers"
          :key="tx.hash + index"
          class="ant-table-row ant-table-row-level-0"
          :data-row-key="tx.hash"
        >
          <!-- 1st Column: Transaction Detail Icon -->
          <td class="ant-table-cell ant_table ant_table_padding_right_none" style="text-align: center;">
            <div class="d-inline-flex td-height28-content-wrap">
              <div class="see-txn-detail" @click="showSummary(tx)">
                <svg class="icon tron-icon eyes-icon" aria-hidden="true">
                  <use xlink:href="/static/media/icons.svg#icon-eyes" />
                </svg>
              </div>
            </div>
          </td>

          <!-- 2nd Column: Timestamp (Formatted Time) -->
          <td class="ant-table-cell ant_table ant_table_time text-left">
            <div class="token_black table_pos">
              <div>{{ getAge(tx.timestamp, 'fixed') }}</div>
            </div>
          </td>

          <!-- 3rd Column: From Address -->
          <td class="ant-table-cell ant_table text-left from_address">
            <div class="ant-table-row-td-address" style="min-width: 130px;">
              <span class="address-container">
                <div class="truncate-ellipsis">                  
                  <template v-if="tx.ownerAddress?.toLowerCase() !== currentAddress">
                    <a :href="`/address/${tx.ownerAddress}`" class="color-tron-red">
                      <div class="ellipsis_box" 
                        @mouseenter="hoveredAddress = tx.ownerAddress"
                        @mouseleave="hoveredAddress = null"
                        :class="{ 'highlighted-address': isHoveredAddress(tx.ownerAddress) }">
                        <div class="line-ellipsis">{{ tx.ownerAddress.slice(0, 24) }}</div>
                        <div>{{ tx.ownerAddress.slice(-6) }}</div>
                      </div>
                    </a>
                  </template>
                  <template v-else>
                    <span class="color-tron-gray">
                      <div class="ellipsis_box">
                        <div class="line-ellipsis">{{ tx.ownerAddress.slice(0, 24) }}</div>
                        <div>{{ tx.ownerAddress.slice(-6) }}</div>
                      </div>
                    </span>
                  </template>
                </div>                
              </span>
            </div>
          </td>

          <!-- 4th Column: To Address -->
          <td class="ant-table-cell ant_table text-left to_address">
            <div class="transactionToAddressWrapper ant-table-row-td-address" style="min-width: 130px;">
              <span class="address-container">
                <span v-if="getToAddressLabel(tx)" class="badge badge-warning">
                  {{ getToAddressLabel(tx) }}
                </span>
                <div v-if="!getToAddressLabel(tx)" class="truncate-ellipsis">
                  <template v-if="tx.toAddress?.toLowerCase() !== currentAddress">
                    <a :href="`/address/${tx.toAddress}`" class="color-tron-red">
                      <div class="ellipsis_box" 
                        @mouseenter="hoveredAddress = tx.toAddress"
                        @mouseleave="hoveredAddress = null"
                        :class="{ 'highlighted-address': isHoveredAddress(tx.toAddress) }">
                        <div class="line-ellipsis">{{ tx.toAddress.slice(0, 24) }}</div>
                        <div>{{ tx.toAddress.slice(-6) }}</div>
                      </div>
                    </a>
                  </template>
                  <template v-else>
                    <span class="color-tron-gray">
                      <div class="ellipsis_box">
                        <div class="line-ellipsis">{{ tx.toAddress.slice(0, 24) }}</div>
                        <div>{{ tx.toAddress.slice(-6) }}</div>
                      </div>
                    </span>
                  </template>
                </div>
              </span>
            </div>
          </td>

          <!-- 5th Column: Icon for Transaction Type -->
          <td class="ant-table-cell ant_table text-left">
            <div class="ant-table-row-td-trc20">
              <div class="d-flex align-items-center">
                <b class="token-img-top" style="margin-right: 4px; position: relative;">
                  <img v-bind:src="tx.tokenLogo" style="vertical-align: top;">
                  <i style="width: 10px; height: 10px;"></i>
                </b>
                <div>
                  <section class="no-wrap" style="width:100px;">
                    <a class="" href="`/address/${tx.tokenId}`">{{ tx.tokenName }} {{ tx.tokenAbbr }}</a>
                  </section>
                  <section v-if="transferType === 'USDT'" class="d-flex no-wrap align-items-center token-address">
                    <div class="truncate-address middle-ellipsis-address">
                      <div style="display: block; table-layout: fixed; width: 100%; white-space: nowrap;">
                        <div class="d-flex">
                          <div class="ellipsis_box">
                            <div class="line-ellipsis">{{ tx.tokenId.slice(0, 8) }}</div>
                            <div>...{{ tx.tokenId.slice(-4) }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </td>

          <!-- 6th Column: Transaction Type -->
          <td class="ant-table-cell ant_table filter-transaction-type text-center">
            <span class="d-inline-flex align-items-center ant-table-row-td-method">
              <span class="text-truncate tron-max-w-120px">                
                <span v-if="tx.ownerAddress === currentTRXAddress" class="badge badge-danger ms-2" style="margin-left: 5px;">转出</span>
                <span v-else-if="tx.toAddress === currentTRXAddress" class="badge badge-success ms-2"  style="margin-left: 5px;">转入</span>
              </span>
            </span>
          </td>

          <!-- 7th Column: Amount (TRX) -->
          <td class="ant-table-cell ant_table text-right">
            <div class="white-space-nowrap">
              <span :class="{'text-green': txDirectionSign(tx) === '+', 'text-red': txDirectionSign(tx) === '-'}" style="margin-right: 5px;">
                <strong>{{ txDirectionSign(tx) }}{{ tx.amount || 0 }}</strong>
              </span>              
            </div>            
          </td>

          <!-- 8th Column: Block Number -->
          <td class="ant-table-cell ant_table text-left">
            <div class="white-space-nowrap">
              {{ tx.block }}
            </div>
          </td>

          <!-- 9th Column: Transaction Hash -->
          <td class="ant-table-cell ant_table text-right">
            <div class="table-txn-remark-wrap">
              <div class="d-flex align-items-center position-relative">
                <a-tooltip>
                  <template #title>
                    <div style="word-break: break-all;">{{ tx.hash }}</div>
                  </template>
                  <div class="ellipsis_box" @click="copyToClipboard(tx.hash)" style="cursor:pointer;">
                    <div class="line-ellipsis">{{ tx.hash.slice(0, 8) }}</div>
                    <div>...{{ tx.hash.slice(-8) }}</div>
                  </div>
                </a-tooltip>                
              </div>
            </div>
          </td>
                    
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pagination" style="margin-top: 20px; display: flex; gap: 5px; justify-content: flex-end;">
    <button class="page-btn" :disabled="currentPage === 1" @click="handlePageChange(currentPage - 1)">
      <svg class="icon tron-icon" aria-hidden="true">
        <use xlink:href="/static/media/icons.svg#icon-icon-left" />
      </svg>
    </button>

    <button class="page-btn" v-if="paginationRange[0] > 1" @click="handlePageChange(1)">1</button><span v-if="paginationRange[0] > 2">...</span>

    <button v-for="page in paginationRange" :key="page" :class="['page-btn', { active: currentPage === page }]" @click="handlePageChange(page)">{{ page }}</button>

    <span v-if="paginationRange[paginationRange.length - 1] < totalPages - 1">...</span>
    <button class="page-btn" v-if="paginationRange[paginationRange.length - 1] < totalPages" @click="handlePageChange(totalPages)">
      {{ totalPages }}
    </button>

    <button class="page-btn" :disabled="currentPage === totalPages" @click="handlePageChange(currentPage + 1)">
      <svg class="icon tron-icon" aria-hidden="true">
        <use xlink:href="/static/media/icons.svg#icon-icon-right-colorless" />
      </svg>
    </button>
  </div>

  <div v-if="selectedTx" class="floating-summary">
      <div class="summary-content">
        <h5>Transaction Summary</h5>
        <p><strong>Txn Hash:</strong> {{ selectedTx.hash }}</p>
        <p><strong>Block:</strong> {{ selectedTx.block }}</p>
        <p><strong>Timestamp:</strong> {{ selectedTx.timestamp }}</p>
        <p><strong>Type:</strong> {{ selectedTx.contractType }}</p>
        <p><strong>From:</strong> {{ selectedTx.ownerAddress }}</p>
        <p><strong>To:</strong> {{ selectedTx.toAddress }}</p>
        <p><strong>Amount:</strong> {{ selectedTx.amount }}</p>
        <button class="btn btn-danger btn-sm" @click="selectedTx = null">Close</button>
      </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue';
import { h } from 'vue';

export default {
  props: ['address'],
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      now: Date.now(),
      intervalId: null,
      transfers: [],
      transferType: 'trc20',
      options: [
        { label: 'USDT', value: 'trc20' },
        { label: 'TRX', value: 'trx' },        
      ],
      contractInfo: {},
      hoveredAddress: null,
      totalTransfers: 0,
      currentTransfersIn: 0,
      currentTransfersOut: 0,
      currentTransferAmount: 0,
      currentTRXAddress: '',

      selectedTx: null,

      senderAddress: '',
      receiverAddress: '',
      dateRange: [],
      selectedToken: 'USDT',
      hideSmall: null,

      tokenTypes: [        
        { label: 'USDT', value: 'trc20' },
        { label: 'TRX', value: 'trx' },        
      ],

      smallBalances: [
        { label: '不隐藏小额', value: '' },
        { label: '隐藏小额', value: 'hide' },
      ],

      inputStyle: {
        width: '100%',
        height: '40px',
      },

      inputStyleFull: {
        width: '100%',
        height: '40px',
      },

      buttonStyle: {
        height: '40px',
        minWidth: '80px',
      },
    };
  },
  computed: {
    currentAddress() {
      return this.$route.params.address?.toLowerCase() || ''
    },
    totalPages() {
      return Math.ceil(this.totalTransfers / this.pageSize);
    },
    paginationRange() {
      const total = this.totalPages;
      const current = this.currentPage;
      const maxVisible = 5;

      const range = [];
      let start = Math.max(1, current - Math.floor(maxVisible / 2));
      let end = start + maxVisible - 1;

      if (end > total) {
        end = total;
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        range.push(i);
      }

      return range;
    }
  },
  mounted() {
    //console.log('Transfers tab loaded for address:', this.$route.params.address);
    this.fetchTransfersUSDT();
  },
  methods: {
    async fetchTransfersUSDT() {      
      const relatedAddress = this.$route.params.address;
      this.currentTRXAddress = relatedAddress;
      const start = (this.currentPage - 1) * this.pageSize;
      try {

        const params = new URLSearchParams({            
            relatedAddress,
        });

        // Optional filters
        if (this.senderAddress) {
            params.append('fromAddress', this.senderAddress);
        }

        if (this.receiverAddress) {
            params.append('toAddress', this.receiverAddress);
        }

        if (this.dateRange?.length === 2) {
            params.append('start_timestamp', new Date(this.dateRange[0]).getTime());
            params.append('end_timestamp', new Date(this.dateRange[1]).getTime());
        }
                        
        //const res = await fetch(
        //  `https://apilist.tronscanapi.com/api/new/token_trc20/transfers?limit=${this.pageSize}&start=${start}&confirm=&filterTokenValue=1&${params.toString()}`
        //);

        const res = await fetch(
          `https://apilist.tronscanapi.com/api/filter/trc20/transfers?limit=${this.pageSize}&start=${start}&sort=-timestamp&count=true&filterTokenValue=0&${params.toString()}`
        );

        const data = await res.json();
        //console.log("Data TRC20: ", data);
        
        this.transfers = data.token_transfers.map((tx) => {
          let amountRaw = '0';
          let decimals = 6;
          
          if (tx.trigger_info?.parameter?._value) {
            amountRaw = tx.trigger_info.parameter._value;
            decimals = tx.tokenInfo?.tokenDecimal || 6;
          }
          else if (tx.amount) {
            amountRaw = tx.amount;
            decimals = tx.tokenInfo?.tokenDecimal || 6;
          }
          else if (tx.quant) {
            amountRaw = tx.quant;
            decimals = tx.tokenInfo?.tokenDecimal || 6;
          }

          const amount = parseFloat(amountRaw) / Math.pow(10, decimals);

          return {
            hash: tx.transaction_id,
            block: tx.block,
            timestamp: tx.block_ts,
            ownerAddress: tx.owner_address || tx.from_address,
            toAddress: tx.to_address,
            amount: isNaN(amount) ? 0 : amount,
            contractType: tx.event_type || 'Transfer TRX',
            tokenId: tx.tokenInfo.tokenId,
            tokenLogo: tx.tokenInfo.tokenLogo,
            tokenAbbr: tx.tokenInfo.tokenAbbr,
            tokenName: tx.tokenInfo.tokenName
          };
        });
        
        this.totalTransfers = data.total;                

        const totalOut = this.transfers
          .filter(tx => tx.ownerAddress === this.currentTRXAddress)
          .reduce((sum, tx) => sum + tx.amount, 0);

        const totalIn = this.transfers
          .filter(tx => tx.toAddress === this.currentTRXAddress)
          .reduce((sum, tx) => sum + tx.amount, 0);

        this.currentTransfersOut = totalOut.toFixed(6);
        this.currentTransfersIn = totalIn.toFixed(6);

      } catch (error) {
        console.error('Error fetching transfers:', error);
      }
    },
    async fetchTransfersTRXOrig() {
      const address = this.$route.params.address;
      this.currentTRXAddress = address;
      const start = (this.currentPage - 1) * this.pageSize;
      try {

        const API_KEY = process.env.VUE_TRON_PRO_API_KEY;

        const params = new URLSearchParams({            
            address,
        });

        // Optional filters
        if (this.senderAddress) {
            params.append('fromAddress', this.senderAddress);
        }

        if (this.receiverAddress) {
            params.append('toAddress', this.receiverAddress);
        }

        if (this.dateRange?.length === 2) {
            params.append('start_timestamp', new Date(this.dateRange[0]).getTime());
            params.append('end_timestamp', new Date(this.dateRange[1]).getTime());
        }
        
        const res = await fetch(
          `https://apilist.tronscanapi.com/api/transfer?sort=-timestamp&count=true&limit=${this.pageSize}&start=${start}&filterTokenValue=1&${params.toString()}`,
          {
            headers: {
              'TRON-PRO-API-KEY': API_KEY
            }
          }
        );

        const data = await res.json();
        //console.log('Transfer Data: ', data);

        this.transfers = data.data.map((tx) => {
          let amountRaw = '0';
          let decimals = 6;
          
          if (tx.trigger_info?.parameter?._value) {
            amountRaw = tx.trigger_info.parameter._value;
            decimals = tx.tokenInfo?.tokenDecimal || 6;
          }
          else if (tx.amount) {
            amountRaw = tx.amount;
            decimals = tx.tokenInfo?.tokenDecimal || 6;
          }

          const amount = parseFloat(amountRaw) / Math.pow(10, decimals);

          return {
            hash: tx.transactionHash,
            block: tx.block,
            timestamp: tx.timestamp,
            ownerAddress: tx.transferFromAddress,
            toAddress: tx.transferToAddress,
            amount: isNaN(amount) ? 0 : amount,
            contractType: tx.event_type || 'Transfer TRX',
            tokenId: tx.tokenInfo.tokenName,
            tokenLogo: tx.tokenInfo.TokenLogo,
            tokenAbbr: tx.tokenInfo.tokenAbbr,
            tokenName: tx.tokenInfo.tokenName
          };
        });
        
        this.totalTransfers = data.total;
               
        const totalOut = this.transfers
          .filter(tx => tx.ownerAddress === this.currentTRXAddress)
          .reduce((sum, tx) => sum + tx.amount, 0);

        const totalIn = this.transfers
          .filter(tx => tx.toAddress === this.currentTRXAddress)
          .reduce((sum, tx) => sum + tx.amount, 0);

        this.currentTransfersOut = totalOut.toFixed(6);
        this.currentTransfersIn = totalIn.toFixed(6);

      } catch (error) {
        console.error('Error fetching transactions:', error);
      }
    },
    async fetchTransfersTRX() {
      const address = this.$route.params.address;
      this.currentTRXAddress = address;
      const start = (this.currentPage - 1) * this.pageSize;

      const params = new URLSearchParams({
        address,
        page: start,
        limit: this.pageSize,
        type: 'trx' // or 'all' if you want TRX and TRC20 together
      });

      if (this.senderAddress) {
        params.append('sender', this.senderAddress);
      }

      if (this.receiverAddress) {
        params.append('receiver', this.receiverAddress);
      }

      if (this.dateRange?.length === 2) {
        params.append('startTime', new Date(this.dateRange[0]).getTime());
        params.append('endTime', new Date(this.dateRange[1]).getTime());
      }

      try {
        const res = await fetch(`https://u134.com/tronApi.php?${params.toString()}`); // << Use your proxy
        const data = await res.json();
        //console.log('Transfer Data: ', data);

        this.transfers = data.token_transfers.map((tx) => {
          let amountRaw = '0';
          let decimals = 6;

          if (tx.trigger_info?.parameter?._value) {
            amountRaw = tx.trigger_info.parameter._value;
            decimals = tx.tokenInfo?.tokenDecimal || 6;
          } else if (tx.amount) {
            amountRaw = tx.amount;
            decimals = tx.tokenInfo?.tokenDecimal || 6;
          }

          const amount = parseFloat(amountRaw) / Math.pow(10, decimals);

          return {
            hash: tx.transactionHash,
            block: tx.block,
            timestamp: tx.timestamp ?? tx.block_ts,
            ownerAddress: tx.transferFromAddress,
            toAddress: tx.transferToAddress,
            amount: isNaN(amount) ? 0 : amount,
            contractType: tx.event_type || 'Transfer TRX',
            tokenId: tx.tokenInfo?.tokenName,
            tokenLogo: tx.tokenInfo?.tokenLogo,
            tokenAbbr: tx.tokenInfo?.tokenAbbr,
            tokenName: tx.tokenInfo?.tokenName
          };
        });

        this.totalTransfers = data.total;

        const totalOut = this.transfers
          .filter(tx => tx.ownerAddress === this.currentTRXAddress)
          .reduce((sum, tx) => sum + tx.amount, 0);

        const totalIn = this.transfers
          .filter(tx => tx.toAddress === this.currentTRXAddress)
          .reduce((sum, tx) => sum + tx.amount, 0);

        this.currentTransfersOut = totalOut.toFixed(6);
        this.currentTransfersIn = totalIn.toFixed(6);

      } catch (error) {
        console.error('Error fetching transactions:', error);
      }
    },

    getAge(timestamp, displayType = 'sync') {
      if (displayType === 'fixed') {
        const date = new Date(timestamp);
        const pad = (n) => n.toString().padStart(2, '0');

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }

      const diff = Math.floor((this.now - timestamp) / 1000);

      if (diff < 60) return `${diff}s ago`;
      if (diff < 3600) {
        const mins = Math.floor(diff / 60);
        const secs = diff % 60;
        return `${mins}m ${secs}s ago`;
      }
      if (diff < 86400) {
        const hours = Math.floor(diff / 3600);
        const mins = Math.floor((diff % 3600) / 60);
        return `${hours}h ${mins}m ago`;
      }

      const days = Math.floor(diff / 86400);
      const hours = Math.floor((diff % 86400) / 3600);
      return `${days}d ${hours}h ago`;
    },
    getToAddressLabel(tx) {
      const info = this.contractInfo?.[tx.toAddress];
      if (!info) return '';      
      if (info.isToken) {
        const tag = info.publicTag || info.tag1 || info.name || 'Smart Contract';
        return `Smart Contract ${tag}`;
      }

      return ''; // not a token contract
    },
    txDirectionSign(tx) {
      if (!tx || !this.currentAddress) return '';
      const lowerAddr = this.currentAddress.toLowerCase();
      if (tx.toAddress?.toLowerCase() === lowerAddr) return '+';
      if (tx.ownerAddress?.toLowerCase() === lowerAddr) return '-';
      return ''; // Unknown direction
    },
    isHoveredAddress(addr) {
      return (
        this.hoveredAddress &&
        addr?.toLowerCase?.() === this.hoveredAddress?.toLowerCase()
      );
    },
    handlePageChange(page) {
      this.currentPage = page;
      if(this.transferType === "trc20") this.fetchTransfersUSDT();
      if(this.transferType === "trx") this.fetchTransfersTRX();
    },
    selectOption(value) {
      this.transferType = value;
      if(value === "trc20") this.fetchTransfersUSDT();
      if(value === "trx") this.fetchTransfersTRX();
    },

    clearFilters() {
      this.senderAddress = '';
      this.receiverAddress = '';
      this.dateRange = [];
      this.selectedToken = null;
      this.hideSmall = null;
    },
    handleFilter() {
      this.currentPage = 1;
      this.transferType = this.selectedToken;
      if (this.transferType === "trc20") this.fetchTransfersUSDT();
      if (this.transferType === "trx") this.fetchTransfersTRX();
    },

    copyToClipboard(address) {
        navigator.clipboard.writeText(address).then(() => {
            //this.$message.success("地址已复制到剪贴板");
            this.$message.success({
                content: h('div', [
                    h('div', { style: 'font-weight: bold; word-break: break-all; color: black;' }, '地址已复制到剪贴板 ✅'),
                    h('div', { style: 'font-weight: bold; word-break: break-all; color: black;' }, address),
                ]),
                duration: 3,
            });
        }).catch(err => {
            this.$message.error("复制失败");
            console.error(err);
        });
    },

    showSummary(transaction) {
      this.selectedTx = transaction;
    },
  }
};
</script>

<style scoped>
[class^="ant-table"], [class*=" ant-table"] {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    font-size: 14px;
    box-sizing: border-box;
    border-bottom: 1px solid #ddd;
}

.ant-input,
.ant-picker,
.ant-select-selector,
.ant-btn {
  height: 38px !important;
  border-radius: 6px !important;
  font-size: 14px;
}

.ant-table-cell.ant_table_time {
  padding-right: 10px;
}

.ant-table-cell.ant_table:nth-child(3) {
  padding-left: 20px; 
  padding-right: 20px;
}

.ant-table-thead th, .ant-table-tbody td {
  padding: 8px 16px; 
}

.ant-table-row td {
  padding-top: 8px;
  padding-bottom: 8px;
  line-height: 16px;
  vertical-align: middle;
}

.color-tron-gray {
  color: #333 !important;
}
.color-tron-red {
  color: #e95f55 !important;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center !important;
}

.text-green {
  color: green;
}

.text-red {
  color: red;
}

.white-space-nowrap {
  white-space: nowrap;
}

.table-txn-remark-wrap {
  max-width: 350px;  /* Adjust based on your preference */
  overflow: hidden;  
  white-space: nowrap;
}

.ellipsis_box {
  display: flex;
  align-items: center;
  white-space: nowrap;
  padding: 2px 4px; /* Always reserve padding */
  border: 1px solid transparent; /* Reserve space for border */
  border-radius: 4px;
  transition: border-color 0.2s ease-in-out, background-color 0.2s ease-in-out;
}

.ellipsis_box.highlighted-address {
  border-color: #aaa;
  border-style: dashed;
  background-color: rgba(0, 0, 0, 0.03); /* Optional soft highlight */
}

.line-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary-box {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.summary-box > div {
  display: flex;
  gap: 6px;
  align-items: center;
}

.page-btn {
  padding: 5px 10px;
  border: 1px solid #ccc;
  background: #f4f4f4;
  cursor: pointer;
}

.page-btn.active {
  background: #28a745;
  color: #fff;
  border-color: #28a745;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.transfer-type-options {
  display: flex;
  gap: 10px;
}

.badge {
  padding: 6px 12px;
  border-radius: 12px;
  border: 1px solid #ccc;
  cursor: pointer;
  user-select: none;
  transition: 0.2s ease;
}

.badge.active {
  background-color: #1677ff;
  color: white;
  border-color: #1677ff;
}

.floating-summary {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  width: 300px;
}

.summary-content {
  text-align: center;
}

.floating-summary button {
  margin-top: 10px;
}

</style>